import { render, staticRenderFns } from "./GoogleAccess.vue?vue&type=template&id=34baab1c&scoped=true&"
import script from "./GoogleAccess.vue?vue&type=script&lang=js&"
export * from "./GoogleAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34baab1c",
  null
  
)

export default component.exports